export default function getRef(obj) {
    return obj.ref['@ref'].id;
};